import React from 'react'
import "./Home.css"
import MainDash from '../../Components/MainDash/MainDash'

const Home = () => {
  return (
    <div className='main'>
      <MainDash />
    </div>
  )
}

export default Home
